import {
  TextureLoader,
  RepeatWrapping,
  LinearSRGBColorSpace,
  SRGBColorSpace,
} from 'three'
import { textureConfig } from './textureConfig'

const textureLoader = new TextureLoader()
const baseURL = '/assets/textures'

function constructTextureURL(materialFileName) {
  return `${baseURL}/${materialFileName}.webp`
}

export const unloadTextures = (materialKey, materialsMap) => {
  const [key, value] =
    [...materialsMap.entries()].find(
      ([, value]) => value.material.code === materialKey,
    ) || []

  if (value) {
    Object.entries(value.textures).forEach(([textureKey, textureValue]) => {
      if (textureValue) {
        //console.log(`🗑️ Unloading texture: ${textureKey}`)
        textureValue.dispose()
      }
    })

    materialsMap.delete(key)
    //console.log(`🗑️ Removed material: ${materialKey} from materialsMap`)
  }
}

export async function loadTexturesFromJSON(materialData, resolution, onError) {
  console.log(materialData)

  const textureURLs = {
    colorMap: materialData.mapTypes?.baseColor
      ? constructTextureURL(materialData.mapTypes?.baseColor)
      : null,
    normalMap: materialData.mapTypes?.normal
      ? constructTextureURL(materialData.mapTypes?.normal)
      : null,
    roughnessMap: materialData.mapTypes?.roughness
      ? constructTextureURL(materialData.mapTypes?.roughness)
      : null,
    opacityMap: materialData.mapTypes?.opacity
      ? constructTextureURL(materialData.mapTypes?.opacity)
      : null,
    metalnessMap: materialData.mapTypes?.metalness
      ? constructTextureURL(materialData.mapTypes?.metalness)
      : null,
    // displacementMap: materialData.mapTypes?.displacement
    //   ? constructTextureURL(materialData.mapTypes?.displacement)
    //   : null,
  }

  // Load all textures in parallel
  const textures = await Promise.allSettled([
    loadTexture(textureURLs.colorMap, SRGBColorSpace, false, onError),
    loadTexture(textureURLs.normalMap, LinearSRGBColorSpace, false, onError),
    loadTexture(textureURLs.roughnessMap, LinearSRGBColorSpace, false, onError),
    loadTexture(textureURLs.opacityMap, LinearSRGBColorSpace, false, onError),
    loadTexture(textureURLs.metalnessMap, LinearSRGBColorSpace, false, onError),
    // loadTexture(
    //   textureURLs.displacementMap,
    //   LinearSRGBColorSpace,
    //   false,
    //   onError,
    // ),
  ])

  // Create an object mapping texture names to their loaded instances or null
  return {
    colorMap: textures[0].status === 'fulfilled' ? textures[0].value : null,
    normalMap: textures[1].status === 'fulfilled' ? textures[1].value : null,
    roughnessMap: textures[2].status === 'fulfilled' ? textures[2].value : null,
    opacityMap: textures[3].status === 'fulfilled' ? textures[3].value : null,
    metalnessMap: textures[4].status === 'fulfilled' ? textures[4].value : null,
    // displacementMap:
    //   textures[5].status === 'fulfilled' ? textures[5].value : null,
  }
}
const loadTexture = (url, colorSpace, flipY = false, onError) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      resolve(null)
      return
    }
    textureLoader.load(
      url,
      (texture) => {
        texture.wrapS = texture.wrapT = RepeatWrapping
        texture.colorSpace = colorSpace
        texture.flipY = flipY
        // texture.repeat.set(2, 3)
        resolve(texture)
      },
      undefined,
      (error) => {
        console.warn('Texture loading error:')
        onError && onError(error)
        reject('Texture loading error')
      },
    )
  })
}
